/**
 * KanbanCardSkeleton - Skeleton loader za Kanban karticu
 * Prikazuje animirani placeholder za ticket karticu
 */

import React from 'react';
import { Skeleton } from 'antd';
import './skeletons.css';

export const KanbanCardSkeleton: React.FC = () => {
  return (
    <div className="kanban-item kanban-card-skeleton">
      {/* Title - 2 lines */}
      <div style={{ marginBottom: '12px' }}>
        <Skeleton.Input
          active
          size="small"
          style={{ width: '100%', height: 14, marginBottom: 6 }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: '70%', height: 14 }}
        />
      </div>

      {/* Footer: Ticket ID and Avatar */}
      <div className="kanban-item-footer">
        <div className="kanban-item-id">
          <Skeleton.Input
            active
            size="small"
            style={{ width: 60, height: 11 }}
          />
        </div>
        <Skeleton.Avatar active size={28} shape="circle" />
      </div>
    </div>
  );
};
